import { call, put, takeLatest, delay, race, take } from 'redux-saga/effects';
import get from 'lodash.get';
import { userApi } from '../../../api';

import { pushNotification } from '../../ui/actions';
import { resetStore } from '../../resetStore/actions';

import * as actions from './actions';

function* deleteAccount() {
  try {
    yield put({ type: actions.DELETE_ACCOUNT_PENDING });
    const { status } = yield call(userApi.deleteAccount);

    if (status === 200) {
      yield put({ type: actions.DELETE_ACCOUNT_FULFILLED });
      yield put(resetStore());
      yield put({ type: actions.RELOAD });
    }
  } catch (e) {
    const description = get(e, 'message');
    yield put({ type: actions.DELETE_ACCOUNT_REJECTED, payload: e });
    yield put(
      pushNotification({
        title: 'Error deleting account',
        description,
        duration: 6,
        type: 'error',
      }),
    );
  }
}

function* reloadPage() {
  yield delay(5000);
  window.location.reload(true);
}

export function* watchDeleteAccount() {
  yield takeLatest(actions.DELETE_ACCOUNT, deleteAccount);
}

export function* watchReloadPage() {
  while (true) {
    yield take(actions.RELOAD);
    yield race({
      reset: call(reloadPage),
      cancel: take(actions.CANCEL_RELOAD),
    });
  }
}
